Shopify.ProductCompare = (() => {
    const updateCompareItemState = (item, isChecked) => {
        const input = item.querySelector('.compare-checkbox');
        const compareIcon = item.querySelector('.compare-icon');
        const text = item.querySelector('.text');
        const visuallyHiddenText = item.querySelector('.visually-hidden');
        const labelText = isChecked ? window.compare.added : window.compare.add;

        if (compareIcon) {
            compareIcon.classList.toggle('is-checked', isChecked);
        }

        if (text) {
            text.innerText = labelText;
        }

        if (visuallyHiddenText) {
            visuallyHiddenText.innerText = labelText;
        }

        if (input) {
            input.checked = isChecked;
        }
    };

    document.addEventListener('click', (event) => {
        const label = event.target.closest('[data-product-compare] .compare-label');

        if (!label) {
            return;
        }

        const item = label.closest('[data-product-compare]');
        const input = item.querySelector('.compare-checkbox');

        if (!input || input.disabled) {
            return;
        }

        event.preventDefault();
        input.checked = !input.checked;
        input.dispatchEvent(new Event('change', { bubbles: true }));
        updateCompareItemState(item, input.checked);
    });

	return {
		setLocalStorageProductForCompare: () => {
			var compareList = JSON.parse(localStorage.getItem('compareItem')) || [];

            if(document.querySelector(`[data-product-compare-handle]`)){
                document.querySelectorAll(`[data-product-compare-handle]`).forEach((item) => {
                    var handle = item.getAttribute('data-product-compare-handle');

                    updateCompareItemState(item, compareList.indexOf(handle) !== -1);
                });
            }

            Shopify.ProductCompare.updateCounterCompare();
		},

		updateCounterCompare: () => {
			var compareList = JSON.parse(localStorage.getItem('compareItem')) || [],
                compareLink = document.querySelector('a[data-compare-link]');

            if(compareLink){
    	        if (compareList.length > 1) {
    	            compareLink.closest('.halo-compareProduct').classList.add('is-show');

                    if(compareLink.querySelector('span.countPill')){
                        compareLink.querySelector('span.countPill').innerText = compareList.length;
                    }
    	        } else {
    	            compareLink.closest('.halo-compareProduct').classList.remove('is-show');
    	        }
            }
		}
	}
})();
